import { getTsCustomerPortalClient } from '@montugroup/circuit-shared/api/customer-portal.client';

const client = getTsCustomerPortalClient();

/**
 * The useProcessCustomerOnboarding hook interfaces with the processCustomerOnboarding contract to enable an external customer to sign up with their onboard key
 *
 * @returns mutate, isPending
 */
export function useProcessCustomerOnboarding() {
  const { mutate, isPending, contractEndpoint } = client.processCustomerOnboarding.useMutation();

  return {
    mutate,
    isPending,
    contractEndpoint,
  };
}
